import { Inject, Component } from '@angular/core';
import { APPNAME, APPVERSION, APPCOPYRIGHT } from '../../app.GlobalSettings';

@Component({
  selector: 'fuse-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FuseFooterComponent {
  appName: String = "Phoenix"
  appVersion: String = "1.0.0.0";
  appCopyright: String = "INTEC For Business Limited (c) 2018";  

  constructor(    
    @Inject(APPNAME) appName: String,
    @Inject(APPVERSION) appVersion: String,
    @Inject(APPCOPYRIGHT) appCopyright: String
  ) {
    this.appName = appName;
    this.appVersion = appVersion;
    this.appCopyright = appCopyright;    
  }
}
